import type { InvoiceStatus } from "@/lib/database.types"

export function invoiceStatusChipClass(status: InvoiceStatus | string): string {
  switch (status) {
    case "paid":
      return "border-transparent bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"
    case "sent":
      return "border-transparent bg-amber-500/15 text-amber-700 dark:text-amber-300"
    case "draft":
      return "border-transparent bg-zinc-500/15 text-zinc-700 dark:text-zinc-300"
    case "void":
      return "border-transparent bg-rose-500/10 text-rose-700 dark:text-rose-300"
    default:
      return "border-transparent bg-zinc-500/10 text-zinc-700 dark:text-zinc-300"
  }
}
